import {createSelector} from 'reselect';

const messageState = (state) => state.v2.ui.message;

/**
 * Retrieves all messages within all locations
 * @param {Object} state
 * @returns {Object}
 */
export const getMessage = createSelector(
  [messageState],
  (messageState) => {
    return messageState;
  }
);
